/**
 * 精选agent
 */
import React from 'react';
import { observer } from 'mobx-react-lite';
import { goAgentChat } from '@/utils/go-agent-chat';

const FeaturedAgent = observer(({ 
    className = '', 
    featuredAgents = [], 
    loading = false, 
    error = null 
}) => {
    if (loading) {
        return (
            <div className="max-w-800px min-w-652px w-full mt-44px mb-4px">
                <div className="text-black mb-16px">
                    <span className="text-14px font-bold">精选Agent</span>
                </div>
                <div className="container mx-auto">
                    <div className="grid grid-cols-3 gap-4">
                        {[1, 2, 3, 4, 5, 6].map((index) => (
                            <div key={index} className="border-1px border-[rgba(37, 45, 77, 0.05)] rounded-12px bg-[rgba(37,45,77,0.03)] p-16px">
                                <div className="w-full h-80px bg-gray-200 rounded-12px animate-pulse"></div>
                                <div className="text-center pt-16px">
                                    <div className="h-6 bg-gray-200 rounded mb-2 animate-pulse"></div>
                                    <div className="h-4 bg-gray-200 rounded animate-pulse"></div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        );
    }

    if (error) {
        return (
           null
        );
    }

    return (
        <div className="max-w-800px min-w-652px w-full mt-44px mb-4px">
            <div className="text-black mb-16px">
                <span className="text-14px font-bold">精选Agent</span>
            </div>
            <div className="container mx-auto">
                <div className="grid grid-cols-3 gap-4">
                    {featuredAgents.map((service, index) => (
                        <div key={service.uuid} className={[
                            "border-1px border-[rgba(37, 45, 77, 0.05)] rounded-12px",
                            "bg-[rgba(37,45,77,0.03)] p-16px cursor-pointer"
                        ]}
                        onClick={() => goAgentChat(service)}
                        >
                            <img src={service.icon} alt={service.title} className="w-full h-80px object-cover rounded-12px" />
                            <div className="text-center pt-16px">
                                <h2 className="text-xl font-bold truncate">{service.title}</h2>
                                <div className="text-gray-600 truncate">{ service.intro}</div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

        </div>
    );
});
export default FeaturedAgent;
